module.exports = __webpack_public_path__ + "videos/f376a2d6f85f6b9061a9bdf6b2903910.mp4";